import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {AuthService} from "../../../../modules/auth/api/service/auth.service";
import {environment} from "../../../../../environments/environment";
import {NavController} from "@ionic/angular";

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(
      private authService: AuthService,
      private router: Router,
      private navController: NavController) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      console.log('interceptor');
      if (request.url.startsWith(environment.webserviceUrl)) {
          const token = this.authService.tokenContentSnapshot?.token;
          if (token && !request.headers.has('Authorization')) {
              request = request.clone({
                  setHeaders: {
                      Authorization: `Bearer ${token}`,
                      'Cache-Control': 'no-cache, no-store, must-revalidate'
                  }
              });
          }
      }
     return next.handle(request).pipe( tap(() => {},
          (err: any) => {
          if (request.url.startsWith(environment.webserviceUrl)) {
              if (err instanceof HttpErrorResponse) {
                  if (err.status === 401) {
                      this.authService.logout(false);
                      this.navController.navigateRoot('authentication/login');
                  }
              }
          }
          }));
  }
}
